export const CATS = ['Economy', 'Midsize', 'SUV', 'Luxury', 'Truck', 'Sports', 'Van', 'Electric'];
export const TRANS = ['Automatic', 'Manual', 'CVT'];
export const FUELS = ['Gas', 'Electric', 'Gas/Hybrid', 'Diesel'];
export const STATUSES = ['Available', 'In Maintenance', 'Inactive'];
export const MAINT_TYPES = ['Oil Change', 'Tire Rotation', 'Brake Service', 'Full Inspection', 'AC Service', 'Detailing', 'Transmission Service', 'Engine Repair', 'Battery Replacement', 'Windshield Repair', 'Recall Service', 'Other'];
export const PRIORITIES = ['Critical', 'High', 'Medium', 'Low'];
export const MAINT_STATUSES = ['Scheduled', 'In Progress', 'Completed', 'Cancelled'];

export const TX_LOCS = [
  { id: 'dfw', name: 'DFW Airport', city: 'Dallas/Fort Worth' },
  { id: 'dal', name: 'Dallas Love Field', city: 'Dallas' },
  { id: 'dal-dt', name: 'Dallas Downtown', city: 'Dallas' },
  { id: 'ftw', name: 'Fort Worth', city: 'Fort Worth' },
  { id: 'iah', name: 'IAH Airport', city: 'Houston' },
  { id: 'hou', name: 'Hobby Airport', city: 'Houston' },
  { id: 'hou-dt', name: 'Houston Downtown', city: 'Houston' },
  { id: 'aus', name: 'Austin-Bergstrom', city: 'Austin' },
  { id: 'aus-dt', name: 'Austin Downtown', city: 'Austin' },
  { id: 'sat', name: 'SAT Airport', city: 'San Antonio' },
  { id: 'sa-dt', name: 'San Antonio Downtown', city: 'San Antonio' },
  { id: 'elp', name: 'El Paso Airport', city: 'El Paso' },
  { id: 'crp', name: 'Corpus Christi', city: 'Corpus Christi' },
  { id: 'lbb', name: 'Lubbock', city: 'Lubbock' },
  { id: 'ama', name: 'Amarillo', city: 'Amarillo' },
];

export const locById = (id) => TX_LOCS.find((l) => l.id === id);
export const locName = (id) => {
  const l = locById(id);
  return l ? `${l.name} — ${l.city}` : id.toUpperCase();
};

export const priorityColor = { Critical: '#FEE2E2', High: '#FEF3C7', Medium: '#DBEAFE', Low: '#F0FDF4' };
export const priorityText = { Critical: '#991B1B', High: '#92400E', Medium: '#1E40AF', Low: '#166534' };
export const maintStatusColor = { Scheduled: '#EFF6FF', Completed: '#F0FDF4', 'In Progress': '#FEF9C3', Cancelled: '#FEF2F2' };
export const maintStatusText = { Scheduled: '#1E40AF', Completed: '#166534', 'In Progress': '#713F12', Cancelled: '#991B1B' };
export const vehicleStatusBadge = {
  Available: { bg: '#DCFCE7', tx: '#166534' },
  'In Maintenance': { bg: '#FEF3C7', tx: '#92400E' },
  Inactive: { bg: '#F1F5F9', tx: '#475569' },
};
